import { makeStyles } from '@material-ui/core/styles';

const styles = {
  autocomplete: {
    width: '100%',
    margin: '5px 0 5px 5px',
  },
};
export const useStyles = makeStyles(styles);
